const configState = {
  Roles: [],
  Nations: [],
  NationsEmployee: [],
  Partners: [],
  PartnerNations: [],
  PartnerEmployees: [],
  RequestEmployees: [],
  AllNations: []
};

export default configState;